import { connect } from 'react-redux';
import React from 'react';
import {
    CmsPageContainer as SourceCmsPageContainer,
    mapStateToProps,
    mapDispatchToProps,
} from 'SourceRoute/CmsPage/CmsPage.container';
import CmsPageComponent from './CmsPage.component';
import { LOADING_TIME } from '@scandipwa/scandipwa/src/route/CategoryPage/CategoryPage.config';
import { debounce } from '@scandipwa/scandipwa/src/util/Request/Debounce';
import { scrollToTop } from '@scandipwa/scandipwa/src/util/Browser';

export {
    mapStateToProps,
    mapDispatchToProps,
};

export class CmsPageContainer extends SourceCmsPageContainer {
    componentDidMount() {
        const {
            isOffline,
            isOnlyPlaceholder,
            isLoading,
        } = this.props;

        const { isPrefetchValueUsed } = window;

        scrollToTop();

        if (isOffline && isLoading) {
            debounce(this.setOfflineNoticeSize, LOADING_TIME)();
        }

        if (!isOnlyPlaceholder && !isPrefetchValueUsed) {
            this.requestPage();
        }
    }

    componentDidUpdate(prevProps) {
        const {
            currentUrl,
            pageIdentifiers,
            pageIds,
            cmsPage,
            isLoading,
        } = this.props;

        const {
            currentUrl: prevCurrentUrl,
            pageIdentifiers: prevPageIdentifiers,
            pageIds: prevPageIds,
            cmsPage: prevCmsPage,
        } = prevProps;

        const { isPrefetchValueUsed } = window;

        if (
            ((currentUrl !== prevCurrentUrl
                || pageIds !== prevPageIds
                || pageIdentifiers !== prevPageIdentifiers)
                && !isLoading)
            && !isPrefetchValueUsed
        ) {
            this.requestPage();
        }

        if (JSON.stringify(cmsPage) !== JSON.stringify(prevCmsPage) || isPrefetchValueUsed) {
            this.onPageLoad();
        }

        // for accrodian container toggle bar
        // const accordianContainer = document.querySelectorAll('.accordion-contianer');

        // if (accordianContainer.length > 0) {
        //     for (let i = 0; i < accordianContainer?.length; i++) {
        //         accordianContainer[i].onclick = function () {
        //             const active = this.classList.toggle("active");
        //             const acco = this.querySelector('.accordion');
        //             const panel = this.querySelector('.panel');

        //             if (active) {
        //                 panel.style.display = "block";
        //                 acco.classList.add("active")
        //             } else {
        //                 panel.style.display = "none";
        //                 acco.classList.remove("active")
        //             }
        //         };
        //     }
        // }

        // // for faq ite,s toggle bar
        // const faqItems = document.getElementsByClassName('faq-item');

        // if (faqItems.length > 0) {
        //     for (let i = 0; i < faqItems?.length; i++) {
        //         faqItems[i].onclick = function () {
        //             const active = this.classList.toggle("active");
        //         };
        //     }
        // }

        // // for homepage appointment popup
        // const bookappoinetment = document.getElementById("appointment");

        // if (bookappoinetment) {
        //     bookappoinetment.onclick = function () {
        //         const bookappoinetmentmodel = document.getElementById("appointment-popup");
        //         if (bookappoinetmentmodel) {
        //             bookappoinetmentmodel.style.display = "flex";

        //             const bookappoinetmentmodelcloseicon = document.getElementsByClassName("appointment_closeIcon");
        //             if (bookappoinetmentmodelcloseicon?.length > 0) {
        //                 bookappoinetmentmodelcloseicon[0].onclick = function () {
        //                     bookappoinetmentmodel.style.display = "none";
        //                 }
        //             }
        //         }
        //     }
        // }
    }

    componentWillUnmount() {
        window.isPrefetchValueUsed = false;
    }

    updateBreadcrumbs() {
        const {
            toggleBreadcrumbs,
            isBreadcrumbsActive,
            cmsPage,
            updateBreadcrumbs
        } = this.props;

        toggleBreadcrumbs(isBreadcrumbsActive);
        updateBreadcrumbs(cmsPage);
    }

    render() {
        return (
            <CmsPageComponent
                {...this.containerProps()}
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CmsPageContainer);
